import { Component, h, Prop } from "@stencil/core"
import { PaymentMethodEnum, PaymentMethodEnumsObj } from "../../enums/PaymentMethodEnum"
import { validateHorizontalMarkSizeEnum, validatePaymentMethodEnum } from "../../helpers/Validators"
import { HorizontalMarkSizeEnum, HorizontalMarkSizeEnumsObj } from "../../enums/HorizontalMarkSizeEnum"
import { srcScreenError } from "../../helpers/CommonRenders"
import clickToPayMarkAsset from "../../assets/clickToPay/horizontal-click-to-pay.svg"
import mastercardAsset from "../../assets/clickToPay/mastercard.svg"
import visaAsset from "../../assets/clickToPay/visa-blue.svg"
import amexAsset from "../../assets/clickToPay/amex.svg"
import discoverAsset from "../../assets/clickToPay/discover.svg"

const NETWORK_ASSETS: Record<string, { alt: string; src: string }> = {
  master: { alt: "Mastercard", src: mastercardAsset },
  visa: { alt: "Visa", src: visaAsset },
  amex: { alt: "American Express", src: amexAsset },
  discover: { alt: "Discover", src: discoverAsset },
}

/**
 * The component containing the horizontal mark for the Click To Pay systems.
 */
@Component({
  tag: "horizontal-mark",
  styleUrl: "HorizontalMark.scss",
})
export class HorizontalMark {
  /**
   * Merchant site preferred locale. Format based on ISO format for language (ISO 639-1) and country code
   * (ISO 3166-1 alpha-2). The language and country should be separated using an underscore ( _ ).
   * <br /><br />
   * **Supported locale**: en_GB, sv_SE, pl_PL
   * <br /><br />
   * @default en_GB
   */
  @Prop() locale?: string

  /**
   * Indicator which Click to Pay System is supported.
   */
  @Prop() paymentMethod: PaymentMethodEnum | undefined

  /**
   * What size of horizontal mark should be used.
   */
  @Prop() horizontalMarkSize: HorizontalMarkSizeEnum | undefined

  private errorMessage: string[]

  componentWillLoad() {
    this.errorMessage = []

    if (this.paymentMethod && !validatePaymentMethodEnum(this.paymentMethod)) {
      this.errorMessage.push("'paymentMethod' prop is not valid")
    }

    if (this.horizontalMarkSize && !validateHorizontalMarkSizeEnum(this.horizontalMarkSize)) {
      this.errorMessage.push("'horizontalMarkSize' prop is not valid")
    }
  }

  getHorizontalMarksAssets = (): { alt: string; src: string }[] => {
    const paymentMethod = this.paymentMethod ? this.paymentMethod : PaymentMethodEnumsObj.MC_VISA_AMEX_DISC
    return paymentMethod.split(",").map(method => NETWORK_ASSETS[method])
  }

  render() {
    if (this.errorMessage.length > 0) {
      return srcScreenError("Horizontal Mark", this.errorMessage)
    }

    const size = this.horizontalMarkSize ? this.horizontalMarkSize : HorizontalMarkSizeEnumsObj.S16

    return (
      <div class={`horizontalMark horizontalMark--${size}`} role="img" aria-label="Click to Pay cards">
        <div class="clickToPayMark">
          <img class="horizontalMarkImage" src={clickToPayMarkAsset} alt="" />
        </div>
        <div class="networkMarks">
          {this.getHorizontalMarksAssets().map(asset => (
            <img class="horizontalMarkImage" src={asset.src} alt={asset.alt} />
          ))}
        </div>
      </div>
    )
  }
}
